"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _infoMessage = require("@/api/infoMessage");
var _throttleDebounce = require("throttle-debounce");
var _permission = require("@/utils/permission");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import creatProduct from './creatProduct'
// 权限判断函数
var _default = {
  name: 'InfoMessage',
  // components: { creatProduct },
  data: function data() {
    return {
      listLoading: true,
      idList: [],
      pram: {},
      inputList: ['yhzczs', 'yhsmzsye', 'yhzczs', 'yhsmzsye', 'yqzczsje', 'yqczje'],
      orList: ['txczzs', 'yqzczs', 'yqczzs'],
      czzsms1: ['czzsms'],
      czzsms2: ['yqczzsms'],
      czjsList: ['czje'],
      isCreate: 0,
      userInfo: {},
      tableData: {
        data: [],
        total: 0
      },
      czljjeList1: [],
      czljjeList2: [],
      showList1: [],
      showList2: []
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    setName: function setName(key) {
      return this.$t(key);
    },
    checkPermi: _permission.checkPermi,
    deleteItem: function deleteItem(data, index, table) {
      var _this = this;
      if (data.id) {
        (0, _infoMessage.deleteSystemConfig)({
          id: data.id
        }).then(function () {
          _this.$message.success(_this.$t('sccg'));
          _this.getList();
        });
      } else {
        this[table].splice(index, 1);
      }
    },
    addItem: function addItem(table) {
      this[table].push({
        key: table == 'czljjeList1' ? "czje" : "yqczje",
        condition: "",
        value: "",
        remark: table == 'czljjeList1' ? this.$t('czlje') : this.$t('czzsje')
      });
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _infoMessage.getAwardConfig)().then(function (res) {
        _this2.czljjeList1 = res.filter(function (item) {
          return item.key == 'czje';
        });
        _this2.czljjeList2 = res.filter(function (item) {
          return item.key == 'yqczje';
        });
        var list = res.filter(function (item) {
          return item.key != 'czje' && item.key != 'yqczje';
        });
        _this2.showList1 = list.slice(0, 4);
        _this2.showList2 = list.slice(4, list.length);
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;
      this.listLoading = true;
      var list = [].concat(_toConsumableArray(this.showList1), _toConsumableArray(this.showList2), _toConsumableArray(this.czljjeList1), _toConsumableArray(this.czljjeList2));
      var data = {
        config_list: list.map(function (item) {
          var id = item.id,
            remark = item.remark,
            value = item.value,
            key = item.key,
            condition = item.condition;
          return {
            id: id,
            remark: remark,
            value: value,
            key: key,
            condition: condition
          };
        })
      };
      var isCreate = sessionStorage.getItem('isCreate');
      (0, _infoMessage.saveSystemConfig)(data).then(function (res) {
        _this3.$message.success(_this3.$t('xgcg'));
        _this3.getList();
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    }
  }
};
exports.default = _default;